var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 26C33.0841 26 38.8269 20.1797 38.8269 13C38.8269 5.8203 33.0841 0 26 0C18.9159 0 13.1731 5.8203 13.1731 13C13.1731 20.1797 18.9159 26 26 26ZM19.9293 26.547C15.0412 23.4984 8.57109 24.9034 6.35348 30.2686C5.12884 33.2314 4.13148 36.5056 4.05178 39.4333C4.00158 41.2773 4.14533 43.2978 4.3586 45.169C4.81723 49.1932 8.31553 52 12.3125 52H39.6876C43.6846 52 47.1829 49.1931 47.6416 45.169C47.8548 43.2978 47.9986 41.2773 47.9484 39.4333C47.8687 36.5056 46.8713 33.2314 45.6467 30.2686C43.4291 24.9034 36.959 23.4984 32.0709 26.547L31.6022 26.8393C28.1667 28.982 23.8335 28.982 20.3979 26.8393L19.9293 26.547Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/person-icon.66701bf114e931ae349a0fe3710a06e8.svg";
export { ForwardRef as ReactComponent };